export default __webpack_public_path__ + "0c4829ef8c82fd6d2be51155bcde6c0b.png";